var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { v4 as uuidv4 } from 'uuid';
import { ajaxSend } from 'api/api';
export default class AnnouncementAdapter {
    constructor() {
        this._items = [];
    }
    getItemForCallback(id) {
        const items = this._items;
        const item = items.find((item) => item.id === id);
        if (!item) {
            return undefined;
        }
        const { id: _id, name } = item, rest = __rest(item, ["id", "name"]);
        return Object.assign(Object.assign({}, rest), { label: name || '' });
    }
    getItemFromURL(url) {
        const items = this._items;
        return items.find((item) => item.url === url);
    }
    getFormattedItem(announcement) {
        const { url } = announcement;
        const items = this._items;
        return items.find((item) => item.url === url);
    }
    getItems() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { uploads }, } = yield ajaxSend({
                path: '/v1/uploads/announcement',
            });
            const items = uploads.map(({ pretty_name: name, url }) => ({
                id: uuidv4(),
                name,
                url,
            }));
            this._items = items.map((item, index) => {
                var _a;
                return (Object.assign(Object.assign({}, item), { author: ((_a = uploads[index].created_by) === null || _a === void 0 ? void 0 : _a.name) || '' }));
            });
            return items;
        });
    }
    upload(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { download_url, upload_url }, } = yield ajaxSend({
                path: '/v1/uploads/presigned_url/announcement',
                method: 'POST',
                data: {
                    pretty_name: file.name,
                    content_type: file.type,
                },
            });
            yield fetch(upload_url, {
                method: 'PUT',
                headers: {
                    contentType: file.type,
                },
                body: file,
            });
            return download_url;
        });
    }
}
